import { Injectable } from '@angular/core';
import { MarketplaceParameter } from 'src/app/global/interfaces/marketplace-parameter';
import { SessionService } from 'src/app/global/services/session.service';
import { CarroComprasService } from 'src/app/view-model/services/carro-compras.service';
import { MarketplaceRedirectService } from 'src/app/view-model/services/marketplace-redirect-vm.service';
import { TokenSaverService } from 'src/app/view-model/services/token-saver.service';
import { environment } from 'src/environments/environment';

@Injectable()
export class MarketplaceRedirectProvider extends MarketplaceRedirectService {
  private portalPublicoRedirectUrl = environment.redirections.portalPublico;
  private marketplaceRedirectUrl = environment.redirections.marketplace;
  private oldFormularyRedirectUrl = environment.redirections.marketplace;
  private portalPrivadoUrl = environment.redirections.portalPrivado;
  private cartConfig = environment.urlQueryParam;
  private portalTbkAmigoUrl = environment.redirections.urlTbkAmigo;
  private backofficeRedirectUrl = environment.redirections.urlBackoffice;

  private trazabilidadUrl = environment.redirections.trazabilidad;

  constructor(private carroComprasService: CarroComprasService, private tokenSaver: TokenSaverService, private sessionService: SessionService,) {
      super();
  }

  redirect(): void {
    window.location.href = this.marketplaceRedirectUrl;
  }

  redirectOld(): void {
    window.location.href = this.oldFormularyRedirectUrl;
  }

  redirectPortalPublico(): void {
    window.location.href = this.portalPublicoRedirectUrl;
  }

  private redirectWithProductsUrl(attachToken = false): URL {
    console.log(this.sessionService.getEjecutivo());
    const marketplaceParameter: MarketplaceParameter = {
      token: '',
      productos: [],
      /* TODO: Check if ejecutivo is null */
      ejecutivo: this.sessionService.getEjecutivo()
    };
    if(marketplaceParameter.ejecutivo !== undefined){
      return new URL(this.backofficeRedirectUrl);
    }
    if (attachToken) {
      marketplaceParameter.token = this.tokenSaver.getToken().replace('Bearer ', '');
    }
    if (this.carroComprasService.products[0].cantidad === '0') {
      this.carroComprasService.products[0].cantidad = null;
    }
    if (this.carroComprasService.products[0].amount === '0') {
      this.carroComprasService.products[0].amount = null;
    }
    if (this.carroComprasService.products[0].moneda === 'PESO') {
      this.carroComprasService.products[0].amountUF.replace('.', ',');
    }
    marketplaceParameter.productos = this.carroComprasService.products;

    const encodedParameter = btoa(unescape(encodeURIComponent(JSON.stringify(marketplaceParameter))));
    const url = new URL(this.marketplaceRedirectUrl);
    if (encodedParameter) {
      url.searchParams.append(this.cartConfig.productsParameterName, encodedParameter);
    }
    return url;
  }


  redirectWithProducts(): void {
    window.location.href = this.redirectWithProductsUrl().href;
  }

  redirectToPortalPrivado(): void {
    window.location.href = this.portalPrivadoUrl;
  }

  redirectToTrazabilidad(): void {
    window.location.href = this.trazabilidadUrl;
  }

  redirectWithProductsAndToken(): void {
    const url = this.redirectWithProductsUrl(true);
    window.location.href = url.href;
  }

  redirectToTbkAmigo(): void {
    window.location.href = this.portalTbkAmigoUrl;
  }

}
